import { styled } from 'styled-components';

interface RootSectionProps {
    $firstSideBackgroundColor?: string;
    $secondSideBackgroundColor?: string;
    $padding?: string;
}

export const RootSection = styled.section<RootSectionProps>`
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: stretch;
    justify-content: center;

    /* gradient split background */
    background: linear-gradient(
        90deg,
        ${({ $firstSideBackgroundColor }) => $firstSideBackgroundColor} 50%,
        ${({ $secondSideBackgroundColor }) => $secondSideBackgroundColor} 50%
    );

    min-height: 100%;

    ${({ $padding }) => $padding && `padding: ${$padding};`}
    box-sizing: border-box;
`;

interface GrowingSideProps {
    $backgroundColor?: string;
    $maxWidth?: number;
}

const GrowingSide = styled.div<GrowingSideProps>`
    display: flex;
    align-items: stretch;
    flex: 1;

    ${({ $maxWidth }) =>
        $maxWidth != null &&
        `
      width: ${$maxWidth}px;
      max-width: ${$maxWidth}px;
    `}
`;

export const FirstSide = styled(GrowingSide)`
    justify-content: flex-end;
    background-color: ${({ $backgroundColor, theme }) =>
        $backgroundColor ?? theme.firstSideBackgroundColor};
`;

export const SecondSide = styled(GrowingSide)`
    justify-content: flex-start;
    background-color: ${({ $backgroundColor, theme }) =>
        $backgroundColor ?? theme.secondSideBackgroundColor};
`;

interface ContentProps {
    $maxHeight?: number;
    $minHeight?: number;
    $firstContentAlign?: string;
}

export const Content = styled.div<ContentProps>`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    ${({ $maxHeight }) => $maxHeight != null && `max-height: ${$maxHeight}px;`}
    ${({ $minHeight }) => $minHeight != null && `min-height: ${$minHeight}px;`}

    height: 100%;

    /* default center except when a custom align is passed */
    align-items: ${({ $firstContentAlign }) => $firstContentAlign ?? 'center'};
    justify-content: flex-start;

    overflow: auto;
    width: inherit;
`;
